'use strict';

export default {
  public: {
    controls: {
      yesNo: {
        yes: 'Oui',
        no: 'Non',
        na: 'N/A',
      },
      acknowledgment: {
        text: 'Reconnaissance',
      },
    },
  },
};
